const bookingTypes = [
  { id: 1, sort: 1, name: 'pending' },
  { id: 2, sort: 1, name: 'selectedStandby' },
  { id: 3, sort: 1, name: 'selectedBook' },
  { id: 4, sort: 2, name: 'standby' },
  { id: 5, sort: 3, name: 'booked' },
]

export default bookingTypes
